export default __webpack_public_path__ + "static/media/reg_succes.1f9cb082.svg";